(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  $(document).ready(function () {
    function updateStockStatus(stock) {
      if (!stock) {
        $('.product-text-badge').css('opacity', 0);
      } else {
        $('.product-text-badge').css('opacity', 1);
        $('.product-text-badge span').html(stock);
      }
    }

    function updateBadgeStyle(value) {
      $('.product-text-badge').css({
        backgroundColor: '',
        color: ''
      });

      if (value === 'Magenta' || value === 'Royal Blue') {
        $('.product-text-badge').css({
          backgroundColor: '#FAEFEA',
          color: '#C86904'
        });
      }
    }

    // ✅ On page load — find the checked input and update badge
    var swatch_parents = $('.variant-option__button-label--has-swatch').parents('.variant-option--swatches');
    var $checkedInput = swatch_parents.find('input:checked');
    if ($checkedInput.length > 0) {
      var value = $checkedInput.val();
      var stock = $checkedInput.parent().attr('stock-status');
      updateStockStatus(stock);
      updateBadgeStyle(value);
    } 
    // ✅ Swatch click
$('.variant-option__button-label--has-swatch').on('click', function () {
  var $swatchInput = $(this).find('input');
  var swatchValue = $swatchInput.val();
  var stock = $(this).attr('stock-status');

  updateStockStatus(stock);
  updateBadgeStyle(swatchValue);
});

// ✅ On page load – size checked
var $sizeCheckedInput = $('.variant-option--equal-width-buttons input:checked');

if ($sizeCheckedInput.length) {
  var stock = $sizeCheckedInput.closest('.variant-option__button-label')
    .attr('stock-status');

  updateStockStatus(stock);
}

// ✅ Size click → use SWATCH value
$('.variant-option--equal-width-buttons .variant-option__button-label').on('click', function () {

var $checkedInput = $(this).find('input:checked');

if ($checkedInput.attr('aria-disabled') === 'true') {
  $('.product-text-badge').css('opacity', 0);
} else {
  $('.product-text-badge').css('opacity', 1);

  var stock = $(this).attr('stock-status');

  // 🔑 get ACTIVE swatch value (scoped correctly)
  var swatchValue = $('.variant-option__button-label--has-swatch')
    .find('input:checked')
    .val();

  updateStockStatus(stock);

  if (swatchValue) {
    updateBadgeStyle(swatchValue);
  }
}



});

  });

  } catch(e) { console.error(e); }
})();
})();
